export const ru = {

  translations: {

    ar_tikrai_istrinti_savininka: 'Вы уверены, что хотите удалить владельца? Его пациенты останутся в системе.',
    atnaujinti_sarasa: 'Обновить список',
    ar_tikrai_istrinti_pacienta: 'Вы уверены, что хотите удалить пациента?',
    pdf_atsisiusti: 'Скачать PDF',
    pdf_ruosiamas: 'Подготовка изображений...',
    pdf_ios_info: 'Safari на iPhone и iPad показывает в предпросмотре только первую страницу, поэтому нажмите «Открыть PDF» — документ откроется полностью.',
  }
}

